import { createFileRoute } from '@tanstack/react-router';
import LoginLayout from 'src/features/plugins/outlook/(auth)/login/layout';
import LoginPage from 'src/features/plugins/outlook/(auth)/login/page';

export const Route = createFileRoute('/plugins/outlook/_outlookAuth/login')({
  component: () => (
    <LoginLayout>
      <LoginPage />
    </LoginLayout>
  ),
});
